import {
  PublicClientApplication
} from "@azure/msal-browser";
export class PublicClientApplicationSingleton {
  static _instance;
  static create(configuration) {
    if (PublicClientApplicationSingleton._instance == null) {
      PublicClientApplicationSingleton._instance = new PublicClientApplication(
        configuration
      );
    }
    return PublicClientApplicationSingleton._instance;
  }
}
